import { useFormikContext } from 'formik';
import { AddressFieldProps } from '../../../types/fields';
import { config } from '../../../utils/config';
import { Country } from '../../../utils/countryData';
import CityField from '../CityField';
import ZipCodeField from '../ZipCodeField';
import useAddressCompletion from './useAddressCompletion';

const ZipCodeCityField = ({ context, testIdPrefix }: AddressFieldProps) => {
  const { values } = useFormikContext<any>();

  const selectedCountry: Country = values[context].country;
  const { zipCode: zipCodeConfig } = config.addressForm[selectedCountry].zipCodeCity;
  const { onCityBlur, onZipCodeBlur, suggestedZipCodes } = useAddressCompletion({ context, country: selectedCountry });

  const zipCodeField = (
    <ZipCodeField
      context={context}
      testIdPrefix={testIdPrefix}
      country={selectedCountry}
      onBlur={onZipCodeBlur}
      suggestedZipCodes={suggestedZipCodes}
    />
  );

  return (
    <>
      {zipCodeConfig.position === 'first' && zipCodeField}
      <CityField context={context} testIdPrefix={testIdPrefix} country={selectedCountry} onBlur={onCityBlur} />
      {zipCodeConfig.position === 'second' && zipCodeField}
    </>
  );
};

export default ZipCodeCityField;
